import FinishCard from "./FinishCard";

const SideCard = () => {
  return (
    <>
      <div className="p-3 bg-2 rounded m-b-32">
        <p className="font-14 ff-bold text-black">Get Help</p>
        <div className="d-flex align-items-center gap-3">
          <div className="d-flex align-items-center gap-2 cart-call">
            <img
              src="https://goodhand.b-cdn.net/Assets/cart/phone-icon.svg"
              alt=""
            />
            <a
              href="tel:+97142979997"
              target="_blank"
              style={{ textDecoration: "none" }}
            >
              <p className="mb-0 ff-medium font-12 text-primary">Call</p>
            </a>
          </div>
          <div className="d-flex align-items-center gap-2 cart-whatsap">
            <img
              src="https://goodhand.b-cdn.net/Assets/cart/whatsap-cart.svg"
              alt=""
            />
            <a
              href="https://web.whatsapp.com/send?phone=97142979998"
              target="_blank"
              style={{ textDecoration: "none" }}
            >
              <p className="mb-0 ff-medium font-12">WhatsApp</p>
            </a>
          </div>
        </div>
      </div>
      <FinishCard />
      <div className="p-3 layout-border  rounded">
        <p className="font-14 ff-bold text-black mb-3 border-bottom pb-2">
          Why Trust Goodhand for Dubai Visa Services
        </p>
        <ul className="list-unstyled">
          <li className="d-flex align-items-start mb-2 cart-slots-main mb-4">
            <img
              src="https://goodhand.b-cdn.net/Assets/cart/tick-serv.svg"
              alt="Appointment"
              className="me-2"
              width="20"
            />
            <div>
              <p className="ff-semibold font-13 text-black mb-0">
                Official Government Channel Partner
              </p>
              <p className="ff-medium font-12 text-grey mb-0">
                Applications are processed through authorized GDRFA, MOHRE & Amer channels.
              </p>
            </div>
          </li>
          <li className="d-flex align-items-start mb-2 cart-slots-main mb-4">
            <img
              src="https://goodhand.b-cdn.net/Assets/cart/tick-serv.svg"
              alt="Appointment"
              className="me-2"
              width="20"
            />
            <div>
              <p className="ff-semibold font-13 text-black mb-0">
                ISO-Certified Data Protection
              </p>
              <p className="ff-normal font-11 text-dark mb-0">
                Documents and personal information are handled with international security standards.
              </p>
            </div>
          </li>
          <li className="d-flex align-items-start mb-2 cart-slots-main mb-4">
            <img
              src="https://goodhand.b-cdn.net/Assets/cart/tick-serv.svg"
              alt="Appointment"
              className="me-2"
              width="20"
            />
            <div>
              <p className="ff-semibold font-13 text-black mb-0">
                End-to-End Expertise
              </p>
              <p className="ff-normal font-11 text-dark mb-0">
                From appointments to final approvals, we manage every step with precision.
              </p>
            </div>
          </li>
          <li className="d-flex align-items-start mb-2 cart-slots-main mb-4">
            <img
              src="https://goodhand.b-cdn.net/Assets/cart/tick-serv.svg"
              alt="Appointment"
              className="me-2"
              width="20"
            />
            <div>
              <p className="ff-semibold font-13 text-black mb-0">
                GoodHand Protect™ Assurance
              </p>
              <p className="ff-normal font-11 text-dark mb-0">
                Includes submissions, real-time updates, and dedicated support until success.
              </p>
            </div>
          </li>
        </ul>
      </div>
    </>
  );
};

export default SideCard;
